<template>
  <div>
    <v-card class="elevation-3">
      <v-toolbar card prominent class="on-top">
        <v-toolbar-title v-show="!isSearch">Danh sách xe ({{vehicles.length}})</v-toolbar-title>
        <v-spacer v-show="!isSearch"></v-spacer>
        <v-btn icon v-show="!isSearch" @click="isSearch = true">
          <v-icon>search</v-icon>
        </v-btn>
        <v-btn icon @click="addDialog = true" v-show="!isSearch">
          <v-icon>add</v-icon>
        </v-btn>
        <v-text-field
          v-show="isSearch"
          block
          solo
          single-line
          label="Tìm theo biển số, IMEI"
          ref="searchText"
          append-icon="close"
          class="search-box"
          v-model="searchText"
          @keydown.esc="closeSearch()"
          @click:append="closeSearch()"
        ></v-text-field>
      </v-toolbar>
      <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
        <v-list three-line>
          <template v-for="(vehicle, index) in filterdDatasource">
            <v-list-tile
              avatar
              :key="vehicle.id"
              :color="getSelectedVehicleColor(vehicle)"
              @click="SET_SELECTED_VEHICLES(vehicle)"
              @contextmenu.prevent="openContextMenu($event, vehicle)"
            >
              <v-list-tile-avatar>
                <img :src="getVehicleIcon(vehicle)">
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{vehicle.plate}}</v-list-tile-title>
                <v-list-tile-sub-title v-if="vehicle.deviceType !== 'MTP8'">{{getVehicleStatus(vehicle)}}</v-list-tile-sub-title>
                <v-list-tile-sub-title v-else-if="vehicle.waypoint && vehicle.waypoint.time">Thời gian GPS: {{vehicle.waypoint.time | formatSecondToGPSTime}}</v-list-tile-sub-title>
                <v-list-tile-sub-title>
                  <v-icon small>location_on</v-icon>
                  {{getAddress(vehicle)}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <div class="text-xs-center">
                  <v-menu offset-y>
                    <v-icon slot="activator" color="grey">more_vert</v-icon>
                    <v-list>
                      <v-list-tile
                        v-for="(item, index) in menu"
                        :key="index"
                        @click="item.click(vehicle)"
                        v-show="showItem(item)"
                      >
                        <v-list-tile-title>
                          <v-icon class="menu-item-icon">{{item.icon}}</v-icon>
                          <span>{{item.title}}</span>
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </div>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider v-if="vehicle / 2 !== 0" :key="index*10000"></v-divider>
          </template>
        </v-list>
      </vue-perfect-scrollbar>
    </v-card>
    <div class="text-xs-center">
      <v-dialog width="640" v-model="moreDialog" v-if="selectedVehicle" content-class="dialog-more">
        <v-card class="card-more">
          <v-toolbar card prominent color="grey lighten-3">
            <v-toolbar-title>{{selectedVehicle.plate}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="moreDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <more/>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog width="360" v-model="addDialog">
        <v-card>
          <v-toolbar card prominent color="grey lighten-3">
            <v-toolbar-title>Tạo xe</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="addDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <add @show="addDialog = $event"/>
        </v-card>
      </v-dialog>
      <v-dialog width="360" v-model="turnOffDialog">
        <v-card>
          <v-toolbar card prominent color="grey lighten-3">
            <v-toolbar-title v-if="selectedVehicle">{{selectedVehicle.plate}} - tắt động cơ từ xa</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="turnOffDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container>
            <v-form>
              <p>Cảnh báo: chức năng này chỉ nên sử dụng trong các trường hợp khẩn cấp: bị cướp xe, trộm xe,...</p>
              <p>Động cơ chỉ được tắt khi xe đang di chuyển với vận tốc nhỏ hơn 20 km/h</p>
              <v-btn block flat color="success" @click="restore()">Khôi phục động cơ</v-btn>
              <v-btn block dark round color="red" @click="turnOff()">Tắt động cơ</v-btn>
            </v-form>
          </v-container>
        </v-card>
      </v-dialog>
    </div>
    <!-- Context Menu -->
    <vue-context ref="vehiclesMenu">
      <v-list>
        <v-list-tile v-for="(item, index) in menu" :key="index" @click="item.click()" v-show="showItem(item)">
          <v-list-tile-title>
            <v-icon class="menu-item-icon">{{item.icon}}</v-icon>
            <span>{{item.title}}</span>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </vue-context>
  </div>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import More from './more';
import Add from './add';
import * as MapUtil from '@/utils/maputil';
import * as DateTimeUtil from '@/utils/datetime';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { VueContext } from 'vue-context';

export default {
  name: 'vehicle-list',
  components: { VuePerfectScrollbar, More, Add, VueContext },

  filters: {
    formatSecondToGPSTime (time) {
      return DateTimeUtil.formatSecondToGPSTime(time);
    }
  },
  
  data () {
    return {
      menu: [
        {
          title: 'Bật chống trộm',
          icon: 'lock',
          click: _ => {
            window.getApp.lock();
          }
        },
        {
          title: 'Tắt chống trộm',
          icon: 'lock_open',
          click: _ => {
            window.getApp.unLock();
          }
        },
        {
          title: 'Tắt động cơ từ xa',
          icon: 'power_settings_new',
          click: _ => {
            this.turnOffDialog = true;
          }
        },
        {
          title: 'Xem lại lộ trình',
          icon: 'history',
          click: _ => {
            window.getApp.viewHistory();
          }
        },
        {
          title: 'Cập nhật vị trí',
          icon: 'room',
          click: _ => {
            window.getApp.updateWaypoint();
          }
        },
        {
          title: 'Xem thêm',
          icon: 'open_in_new',
          click: _ => {
            this.moreDialog = true;
          }
        }
      ],
      scrollSettings: {
        maxScrollbarLength: 160
      },
      moreDialog: false,
      addDialog: false,
      turnOffDialog: false,
      isSearch: false,
      filterdDatasource: [],
      searchText: ''
    };
  },

  computed: {
    ...mapGetters(['vehicles', 'selectedVehicle', 'lastWaypointUpdateTime'])
  },
  watch: {
    lastWaypointUpdateTime () {
      this.filterdDatasource = this.vehicles;
      this.search();
      this.$forceUpdate();
    },
    searchText () {
      this.search();
    }
  },
  mounted () {
    if (this.vehicles.length === 0) {
      this.getVehicles().then(res => {
        this.getVehicleWaypoints();
      });
    } else {
      this.filterdDatasource = this.vehicles;
      this.getVehicles();
    }
  },
  methods: {
    ...mapActions(['getVehicles', 'getVehicleWaypoints']),
    ...mapMutations(['SET_SELECTED_VEHICLES', 'SET_VIEW_HISTORY_STATE']),
    getVehicleIcon: vehicles => MapUtil.getVehicleIcon(vehicles),
    getVehicleStatus: vehicle => MapUtil.getVehicleStatus(vehicle),
    getAddress (vehicle) {
      let address = 'Không xác định';
      if (vehicle.waypoint && vehicle.waypoint.data) {
        if (vehicle.waypoint.data.addr !== undefined) {
          address = `${vehicle.waypoint.data.addr},${
            vehicle.waypoint.data.admin
          }`;
        } else {
          address = vehicle.waypoint.data.admin;
        }
        address = address && address.split(',').join(', ');
      }
      return address;
    },
    getSelectedVehicleColor (vehicle) {
      if (this.selectedVehicle && vehicle.id === this.selectedVehicle.id) {
        return 'purple';
      } else {
        return 'black';
      }
    },
    openContextMenu (event, vehicle) {
      this.SET_SELECTED_VEHICLES(vehicle);
      this.$refs.vehiclesMenu.open(event);
    },
    showItem (item) {
      if (item.icon === 'power_settings_new') {
        if (this.selectedVehicle && (this.selectedVehicle.deviceType.toUpperCase() === 'MT20' || this.selectedVehicle.deviceType.toUpperCase() === 'MT30' || this.selectedVehicle.deviceType.toUpperCase() === 'MT20P') && this.selectedVehicle.cutOffEngine) {
          return true;
        } else { 
          return false; 
        }
      } 

      if (item.icon === 'lock' || item.icon === 'lock_open') {
        if (this.selectedVehicle && this.selectedVehicle.deviceType.toUpperCase() === 'MTP8') {
          return false;
        } else { return true }
      }

      if (item.icon === 'room') {
        if (this.selectedVehicle && this.selectedVehicle.deviceType.toUpperCase() === 'MTP8') {
          return true;
          
        } else { return false }
      }

      if (item.icon !== 'open_in_new') {
        if (this.selectedVehicle && this.selectedVehicle.isLocked) {
          return false;
        } else { return true }
      }

      return true; 
    },
    closeSearch () {
      this.isSearch = false;
      this.searchText = '';
    },
    search () {
      if (this.searchText) {
        this.filterdDatasource = this.vehicles.filter(a =>
          (a.plate + a.imei)
            .toLowerCase()
            .includes(this.searchText.toLowerCase())
        );
      } else {
        this.filterdDatasource = this.vehicles;
      }
    },
    turnOff () {
      window.getApp.turnOff(this.selectedVehicle);
      this.turnOffDialog = false;
    },
    restore () {
      window.getApp.restore(this.selectedVehicle);
      this.turnOffDialog = false;
    }
  },
};
</script>

<style scoped>
.drawer-menu--scroll {
  height: calc(100vh - 128px);
  overflow: auto;
}
.vehicle-icon {
  max-width: 32px;
  float: left;
}
.plate {
  float: left;
  margin: 6px 0px 0px 20px;
}
.menu-item-icon {
  font-size: 15pt;
  padding-right: 10px;
}
.purple--text {
  color: black !important;
  background: #fff8e3;
}
.v-context {
  width: 200px !important;
}
.on-top {
  z-index: 3;
}
.search-box {
  margin-top: 6px !important;
}
p {
  text-align: justify;
  line-height: 17pt;
}
.card-more{
  max-height: calc(100vh - 130px);
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/vehicle/components/List.vue